import React from 'react';
import { FiFileText, FiInfo, FiEye } from 'react-icons/fi';
import { FaBuilding } from 'react-icons/fa';
import BankSidebar from '../components/BankSidebar';

export default function SupplierPayment() {
  return (
    <div className="flex h-full font-sans overflow-hidden">
      <BankSidebar />
      <div className="flex-1 flex flex-col bg-[#a6e4e7] p-4 font-sans text-gray-800 overflow-y-auto">
        <div className="flex items-center space-x-2 text-teal-800 mb-4 ml-1">
          <FiFileText className="text-lg opacity-70" />
          <span className="font-medium text-[15px]">Enter payment</span>
        </div>

        <div className="bg-white border border-gray-300 p-5 mb-6 shadow-sm">
          <div className="grid grid-cols-[180px_1fr] gap-y-4 items-center text-[13px]">
            <div className="font-bold text-gray-800">Company</div>
            <div className="flex items-center text-gray-800 font-medium">
              <FaBuilding className="text-[#800080] mr-2 text-[14px]" /> WELL MAY INTERNATIONAL GROUP
            </div>

            <div className="font-bold text-gray-800">Date</div>
            <div className="flex items-center space-x-2">
              <input type="text" value="12/30/2025" readOnly className="border border-gray-300 px-2 py-1 w-28 bg-white text-gray-800 outline-none" />
              <span className="text-gray-400 text-sm border border-gray-300 px-1.5 py-0.5 bg-gray-50 flex items-center justify-center">📅</span>
              <span className="text-gray-600 text-[12px]">Now - Invoice date</span>
            </div>

            <div className="font-bold text-gray-800">Payment method</div>
            <div className="flex items-center space-x-2">
              <select className="border border-gray-300 bg-[#a6e4e7] px-2 py-1 w-48 outline-none text-gray-800">
                <option>Cash</option>
              </select>
              <FiInfo className="text-gray-400 text-[16px]" />
            </div>

            <div className="font-bold text-gray-800">Account</div>
            <div>
              <select className="border border-gray-300 bg-[#a6e4e7] px-2 py-1 w-48 outline-none text-yellow-600 font-bold">
                <option>🏦</option>
              </select>
            </div>

            <div className="font-bold text-gray-800">Number</div>
            <div>
              <input type="text" className="border border-gray-300 px-2 py-1 w-full max-w-lg outline-none bg-white" />
            </div>

            <div className="font-bold text-gray-800 self-start pt-1.5">Comments</div>
            <div>
              <textarea className="border border-gray-300 px-2 py-1 w-full max-w-3xl h-14 outline-none resize-none bg-white"></textarea>
            </div>
          </div>
        </div>

        <div className="overflow-x-auto mb-6 bg-white shadow-sm">
          <table className="min-w-full border-collapse border border-gray-600 text-[12px] text-gray-800">
            <thead>
              <tr className="bg-[#a6e4e7]">
                <th className="border border-gray-600 p-2 font-normal text-left">Invoice</th>
                <th className="border border-gray-600 p-2 font-normal text-left">Ref.<br/>supplier</th>
                <th className="border border-gray-600 p-2 font-normal text-left">Date</th>
                <th className="border border-gray-600 p-2 font-normal text-center">Payment due<br/>on</th>
                <th className="border border-gray-600 p-2 font-normal text-center">Currency</th>
                <th className="border border-gray-600 p-2 font-normal text-right">Amount (inc.<br/>of tax),<br/>original<br/>currency</th>
                <th className="border border-gray-600 p-2 font-normal text-right">Already<br/>paid,<br/>original<br/>currency</th>
                <th className="border border-gray-600 p-2 font-normal text-right">Remain to<br/>pay, original<br/>currency</th>
                <th className="border border-gray-600 p-2 font-normal text-right">Payment<br/>amount,<br/>original<br/>currency</th>
                <th className="border border-gray-600 p-2 font-normal text-right">Amount<br/>(inc. tax)</th>
                <th className="border border-gray-600 p-2 font-normal text-right">Already<br/>paid</th>
                <th className="border border-gray-600 p-2 font-normal text-right">Remaining<br/>unpaid</th>
                <th className="border border-gray-600 p-2 font-normal text-left">Payment amount</th>
                <th className="border border-gray-600 p-2 font-normal text-center w-10"></th>
              </tr>
            </thead>
            <tbody>
              <tr className="bg-white">
                <td className="border border-gray-600 p-2 whitespace-nowrap text-teal-800">
                  <FiFileText className="inline mr-1 text-[#5bc0be]" /> SI2512-0004
                </td>
                <td className="border border-gray-600 p-2">well123</td>
                <td className="border border-gray-600 p-2">12/20/2025</td>
                <td className="border border-gray-600 p-2 text-center whitespace-nowrap">
                  01/31/2026 <span className="text-orange-500 font-bold ml-0.5 text-sm">⚠️</span>
                </td>
                <td className="border border-gray-600 p-2 text-center">HKD</td>
                <td className="border border-gray-600 p-2 bg-[#f9f9f9]"></td>
                <td className="border border-gray-600 p-2 bg-[#f9f9f9]"></td>
                <td className="border border-gray-600 p-2 bg-[#f9f9f9]"></td>
                <td className="border border-gray-600 p-2 bg-[#f9f9f9]"></td>
                <td className="border border-gray-600 p-2 text-right">20,000.00</td>
                <td className="border border-gray-600 p-2 text-right">0.00</td>
                <td className="border border-gray-600 p-2 text-right">20,000.00</td>
                <td className="border border-gray-600 p-1 text-left whitespace-nowrap">
                  <div className="flex items-center">
                    <span className="text-gray-500 mr-1 font-serif font-bold text-sm">↳</span>
                    <input type="text" defaultValue="20000" className="w-20 border border-gray-300 px-1 py-0.5 text-right outline-none bg-white" />
                  </div>
                </td>
                <td className="border border-gray-600 p-2 text-center">
                  <div className="flex justify-center items-center">
                    <FiEye className="text-[#0000a0] text-lg cursor-pointer hover:opacity-70" />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="flex flex-col items-center mt-4 pb-8">
          <label className="flex items-center text-[13px] text-gray-800 mb-4 cursor-pointer font-medium">
            <input type="checkbox" defaultChecked className="mr-2 w-3.5 h-3.5 accent-[#0000a0]" />
            Classify automatically all standard, down payment or replacement invoices as "Paid" when payment is done entirely.
          </label>
          <button className="bg-[#0000a0] text-white px-10 py-1.5 rounded shadow-sm hover:bg-blue-900 font-bold text-sm tracking-wide">
            PAY
          </button>
        </div>
      </div>
    </div>
  );
}